/* eslint-disable react/display-name */
import { forwardRef } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

export const ModalWrapper = forwardRef((props, closeModalRef) => {
  const { children, title, modalId, headerClassName, isFullHeight, onClose } =
    props;

  return (
    <div>
      <input type="checkbox" id={modalId} className="modal-toggle" />
      <div className="modal">
        <div
          className={classNames({
            "modal-box relative rounded-[1.2rem]": !isFullHeight,
            "modal-box relative min-h-full w-full max-w-full rounded-none md:min-h-0 md:max-w-[40rem] md:rounded-lg":
              isFullHeight,
          })}
        >
          <div
            className={`flex items-start ${
              title ? "justify-between" : "justify-end"
            } ${headerClassName}`}
          >
            {title && (
              <h2 className="text-[1.25rem] font-semibold leading-none text-grayDisplay-900 md:text-[1.5rem]">
                {title}
              </h2>
            )}

            <label
              htmlFor={modalId}
              ref={closeModalRef}
              className="cursor-pointer hidden"
            >
              ✕
            </label>

            <button onClick={onClose} className="cursor-pointer">
              ✕
            </button>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
});

ModalWrapper.propTypes = {
  onHide: PropTypes.func,
  title: PropTypes.string,
  modalId: PropTypes.string,
  isFullHeight: PropTypes.bool,
  headerClassName: PropTypes.string,
};

ModalWrapper.defaultProps = {
  isFullHeight: true,
};
